





















import { Component, Vue } from "vue-property-decorator";
import Dashboard from "@/components/Dashboard.vue";
import SidePanel from "@/components/SidePanel.vue";
import LockScreen from "@/components/LockScreen.vue";
import Loader from "@/components/Loader.vue";
import { Button } from "@/types";

import AttendanceIcon from "@/assets/attendance.png";
import CafeteriaIcon from "@/assets/cafeterie.png";
import EisodIcon from "@/assets/eisod.png";
import IntranetIcon from "@/assets/intranet.png";
import JiraIcon from "@/assets/jira.png";
import JobsIcon from "@/assets/jobs.png";
import JusdaIcon from "@/assets/jusda.png";
import MajdaIcon from "@/assets/majda.png";
import PayrollIcon from "@/assets/payroll.png";

@Component({
  components: {
    Dashboard,
    SidePanel,
    LockScreen,
    Loader
  }
})
export default class Home extends Vue {
  private isUnlocked = false;
  private buttons: Button[];

  private isInitialized = false;
  private bc: BroadcastChannel;
  constructor() {
    super();
    this.bc = new BroadcastChannel("login-protocol");
    this.bc.onmessage = this.onReceiveMessage;

    this.bc.postMessage({
      type: "verify"
    });

    this.buttons = [
      {
        text: "Majda",
        imageSrc: MajdaIcon,
        href:
          "https://performancemanager.successfactors.eu/login?company=foxconnczsP2&loginMethod=PWD"
      },
      {
        text: "Web JUSDA",
        imageSrc: JusdaIcon,
        href: "https://www.jusdaeurope.com"
      },
      {
        text: "Intranet",
        imageSrc: IntranetIcon,
        href: "https://intranet.jusdaeurope.com"
      },
      {
        text: "Jobs",
        imageSrc: JobsIcon,
        href: "https://www.jusdaeurope.com/kariera/"
      },
      {
        text: "Bejska\nDocházka",
        imageSrc: AttendanceIcon,
        href: "http://jusda.okbase.cz/"
      },
      {
        text: "Bejska\nPayroll",
        imageSrc: PayrollIcon,
        href: "http://jusda.okbase.cz/"
      },
      {
        text: "EISOD",
        imageSrc: EisodIcon,
        href: "https://eisod/"
      },
      {
        text: "JIRA",
        imageSrc: JiraIcon,
        href: "https://jira.cz.foxconn.com/servicedesk/customer/portals"
      },
      {
        text: "Cafeterie",
        imageSrc: CafeteriaIcon,
        href: "https://sodexo-ucet.cz/"
      }
    ];
  }

  mounted() {
    setTimeout(() => {
      // Animace načítání, během této doby by mělo přijít odpověd na to,
      // zda-li má být uživatel přihlášen nebo odhlášen.
      this.isInitialized = true;
    }, 500);
  }

  private onReceiveMessage(ev: MessageEvent) {
    const { type } = ev.data;
    if (type === "login") {
      this.isUnlocked = true;
    } else if (type === "logout") {
      this.isUnlocked = false;
    }
  }
}
